<script setup lang="ts">

</script>

<template>
<div class="rounded-t-full bg-white">
  <div class="w-full rounded-t-full p-8 bg-white"></div>
  <div class="w-full bg-white">
    <div class="container mx-auto px-5 pb-5 bg-white">
      <slot></slot>
    </div>
  </div>
</div>
</template>

<style scoped>

</style>
